module.exports = __webpack_public_path__ + "img/notification-selected.aa9f7e38.svg";